import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetUserSuggestionsQuery,
  useGetReportShopsQuery,
  useGetReportServicesQuery,
  useGetUserInfoQuery,
} from "../features/user/userApiSlice";
import { useGetUserShopsByBusinessTypeQuery } from "../features/shop/shopApiSlice";
import { useGetMyManagedShopsQuery } from "../features/shop/shopMemberApiSlice";

export const useHomeMadeShopsState = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const [userdash, setUserdash] = useState(1);
  const [shareurl, setShareurl] = useState("");

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  // RTK Query calls
  const { data: shopsData, isLoading: shopsLoading } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "homemadeShop" },
    { skip: !name?._id }
  );

  const { data: suggestionsData } = useGetUserSuggestionsQuery(name?._id, {
    skip: !name?._id,
  });

  const { data: reportShopsData } = useGetReportShopsQuery(name?._id, {
    skip: !name?._id,
  });

  const { data: reportServicesData } = useGetReportServicesQuery(name?._id, {
    skip: !name?._id,
  });

  const { data: userInfoData, isLoading: isUserInfoLoading } = useGetUserInfoQuery(name?._id, {
    skip: !name?._id,
  });

  // Query arg: on /user-dashboard fetch all managed shops; otherwise restrict to homemadeShop
  const managedQueryParams =
    location.pathname === "/user-dashboard"
      ? undefined
      : { businessType: "homemadeShop" };

  const {
    data: managedData,
    isLoading: isManagedLoading,
    refetch: refetchManagedShops,
  } = useGetMyManagedShopsQuery(managedQueryParams, {
    skip: !name?._id,
    refetchOnMountOrArgChange: true,
  });

  // Zero-polling, zero-websocket instant sync across components & browser tabs
  useEffect(() => {
    const handleSync = () => {
      if (typeof refetchManagedShops === "function") {
        refetchManagedShops();
      }
    };

    // 1. Same-tab CustomEvent
    window.addEventListener("shop_invitation_accepted", handleSync);

    // 2. Cross-tab storage event (fires on all other open tabs in 0ms without polling)
    const handleStorage = (e) => {
      if (e.key === "last_shop_membership_action") {
        handleSync();
      }
    };
    window.addEventListener("storage", handleStorage);

    // 3. BroadcastChannel (inter-tab zero-overhead channel)
    let channel;
    if (typeof BroadcastChannel !== "undefined") {
      try {
        channel = new BroadcastChannel("shop_membership_channel");
        channel.onmessage = (event) => {
          if (
            event?.data?.type === "INVITATION_ACCEPTED" ||
            event?.data?.type === "INVITATION_UPDATED"
          ) {
            handleSync();
          }
        };
      } catch (err) {}
    }

    return () => {
      window.removeEventListener("shop_invitation_accepted", handleSync);
      window.removeEventListener("storage", handleStorage);
      if (channel) {
        try {
          channel.close();
        } catch (e) {}
      }
    };
  }, [refetchManagedShops]);

  useEffect(() => {
    const categoryName = shopsData?.data?.Shops?.[0]?.shopCategory?.name;
    if (categoryName) {
      localStorage.setItem("mycategory", categoryName);
    }
  }, [shopsData]);

  return {
    location,
    navigate,
    name,
    homemadeShop: shopsData?.data?.Shops || [],
    managedShops: managedData?.data?.managedShops || [],
    pendingInvitations: managedData?.data?.pendingInvitations || [],
    isManagedLoading,
    isloading: shopsLoading,
    refetchManagedShops,
    showshare,
    setShowshare,
    show,
    setShow,
    userdash,
    setUserdash,
    userimg: userInfoData?.data?.User?.imageUrl,
    isUserimgLoading: isUserInfoLoading,
    suggestdata: suggestionsData?.data || [],
    reportdata: reportShopsData?.data || [],
    servicedata: reportServicesData?.data || [],
    shareurl,
    setShareurl,
    handleCloseshare,
    handleClosemodal,
    handleShowshare,
  };
};
